import React,{Suspense, lazy} from 'react';
import ReactDOM from 'react-dom';
import './scss/main.scss';
import './scss/loading.css';



import firebase from './firebase';
import reportWebVitals from './reportWebVitals';
const App = lazy(() => import('./App'));
ReactDOM.render(
  <React.StrictMode>

  <Suspense fallback = {
<div  className="bodyLoad">
    <div  className="loader">
  <span  className="loader-block"></span>
  <span  className="loader-block"></span>
  <span  className="loader-block"></span>
  <span  className="loader-block"></span>
  <span  className="loader-block"></span>
  <span  className="loader-block"></span>
  <span  className="loader-block"></span>
  <span  className="loader-block"></span>
  <span  className="loader-block"></span>
</div>
</div>
}>
      <App />
  </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
